import React, { useState, useEffect } from 'react';
import { Button, Field, Input, Table, Modal, Message, Toast } from 'react-frontier';
import { Dropdown, Icon } from 'semantic-ui-react';
import { ShipmentItemDetail, ShippingCarrier } from '../SiteClasses';
import classNames from 'classnames';
import API from '../API';

interface SendShipmentModalProps{
	open: boolean,
	onClose: ()=>void,
	shipment_id: number,
	items: ShipmentItemDetail[],
	onSent: (item_ids: number[], data: { carrier_name?: string, tracking_number?: string })=>void,
}

var SendShipmentModal = (props: SendShipmentModalProps)=>{
	var [carrierId, setCarrierId] = useState<number>(null);
	var [trackingNumber, setTrackingNumber] = useState<string>('');
	var [selectedItemIds, setSelectedItemIds] = useState<number[]>([]);
	var [carriers, setCarriers] = useState<ShippingCarrier[]>(null);
	var [prompts, setPrompts] = useState<string[]>(null);
	var [loading, setLoading] = useState<boolean>(false);

	var activeItems = props.items ? props.items.filter(i => !i.shipped && !i.delivered && !i.deleted) : [];

	useEffect(()=>{
		if(!props.open) return;
		setCarrierId(null);
		setTrackingNumber('');
		setSelectedItemIds([]);
		setPrompts(null);
		setLoading(false);
		if(!carriers){
			API.getShippingCarriers().then(res=>{
				if(!res.error) setCarriers(res.data);
			});
		}
	}, [props.open]);

	var selectAll = ()=>{
		setSelectedItemIds(ids => ids.length === activeItems.length ? [] : activeItems.map(i => i.item_id));
	};

	var toggleItem = (item_id: number)=>{
		setSelectedItemIds(ids =>
			ids.includes(item_id) ? ids.filter(id => id !== item_id) : [...ids, item_id]
		);
	};

	var send = ()=>{
		var errors: string[] = [];
		var trimmedTrackingNumber = trackingNumber.trim() || undefined;
		if(selectedItemIds.length === 0) errors.push('Selecciona al menos un equipo a enviar.');
		if(trimmedTrackingNumber && !carrierId) errors.push('Selecciona una paquetería para el número de guía.');
		if(errors.length > 0) return setPrompts(errors);

		setLoading(true);
		setPrompts(null);
		var carrier = carriers?.find(c => c.carrier_id === carrierId);

		API.shipShipmentItems(props.shipment_id, selectedItemIds, {
			carrier_id: carrierId || undefined,
			tracking_number: trimmedTrackingNumber,
		}).then(res=>{
			if(res.error) return setPrompts([res.message]);
			Toast.success('Equipos marcados como enviados correctamente');
			props.onSent(selectedItemIds, {
				carrier_name: carrier?.carrier_name,
				tracking_number: trimmedTrackingNumber
			});
			props.onClose();
		}).catch(()=>{
			setPrompts(['Hubo un error al registrar el envío. (SSM-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	};

	return <>
		<Modal open={props.open} onClose={props.onClose} size='tiny'>
			<Modal.Header>Marcar como enviados</Modal.Header>
			<Modal.Content>
				<Field amount={2}>
					<Field label='Paquetería'>
						<Dropdown
							fluid
							selection
							clearable
							placeholder='Sin paquetería...'
							value={carrierId}
							options={carriers ? carriers.map(c => ({ key: c.carrier_id, value: c.carrier_id, text: c.carrier_name })) : []}
							onChange={(e, { value })=> setCarrierId((value as number) || null)}
						/>
					</Field>
					<Input
						label='Número de guía'
						value={trackingNumber}
						onChange={(v: string)=> setTrackingNumber(v)}
					/>
				</Field>
				<div style={{ textAlign: 'center', marginTop: 10 }}>
					<Button text='Seleccionar todos' color='black' onClick={selectAll} />
				</div>
				<Table
					title='Equipos'
					selectable
					fitted
					style={{ marginTop: 10 }}
					headers={[
						<div style={{ textAlign: 'center' }}>
							<i className="checkmark icon" style={{ marginRight: 0 }}></i>
						</div>,
						'ID', 'Tipo', 'Nombre', 'Serie'
					]}
					collapsingIndexes={[0, 1, 4]}
					onClick={(v: any[])=>{
						var itemId = v[1];
						toggleItem(itemId);
					}}
					data={activeItems.length === 0 ? [] : activeItems.map(item => {
						var selected = selectedItemIds.includes(item.item_id);
						return [
							<i className={classNames('large icon circle', {
								check: selected,
								outline: !selected
							})}></i>,
							item.item_id,
							item.type_name,
							item.item_name || <Icon name='minus' />,
							item.serial_number || <Icon name='minus' />,
						];
					})}
				/>
				<Message type='error' list={prompts} />
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={props.onClose} />
				<Button text='Enviar' color='black' loading={loading} onClick={send} />
			</Modal.Actions>
		</Modal>
	</>;
};

export default SendShipmentModal;
